import kTileCount from '@envclient/envengine/src/config/koenigsburg/koenigsburg_tilecount.json';
import koenigsburgTileTypesJson from '@envclient/envengine/src/config/koenigsburg/koenigsburg_tilemap.json';
import { KTileDef } from '@envclient/envengine/src/envs/koenigsburg/KTileGameConfig';

const koenigsburgTileTypes: Record<number, KTileDef> = koenigsburgTileTypesJson as Record<number, KTileDef>;

const getKTileDef = (type: number): KTileDef => {
  return koenigsburgTileTypes[type];
};

export { kTileCount, getKTileDef };
